import { useMemo } from 'react';

import { useAccessToken } from '../auth/use-access-token';
import { StoreService } from '../services/stores';

export function useStoreService() {
  const getAccessTokenSilently = useAccessToken();

  return useMemo(() => new StoreService(getAccessTokenSilently), [getAccessTokenSilently]);
}
